import type { PulseItem } from './pulseSchema';

/** Map Braze `items` → Pulse `items_payload` (same shape; null when empty). */
export const resolveItemsPayload = (
  items: PulseItem[] | null | undefined
): PulseItem[] | null =>
  Array.isArray(items) && items.length > 0 ? items : null;

/** Strip Braze `items` from spread payloads; set canonical `items_payload`. */
export const withItemsPayload = <
  T extends Record<string, unknown> & { items?: PulseItem[] | null | undefined },
>(
  payload: T
): Omit<T, 'items'> & { items_payload: PulseItem[] | null } => {
  const { items, ...rest } = payload;
  return {
    ...rest,
    items_payload: resolveItemsPayload(items),
  };
};
